import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
  }

  .checkbox {
    position: relative;
    display: inline-flex;
    align-items: flex-start;
    font-family: var(--webmodule-control-font-family);
    font-weight: var(--webmodule-control-font-weight);
    color: var(--webmodule-control-label-color);
    vertical-align: middle;
    cursor: pointer;
  }

  .checkbox--small {
    --toggle-size: var(--webmodule-toggle-size-small);
    font-size: var(--webmodule-control-font-size-small);
    //padding: calc(var(--webmodule-spacing-x-small) + 2px) 0;
  }

  .checkbox--medium {
    --toggle-size: var(--webmodule-toggle-size-medium);
    font-size: var(--webmodule-control-font-size-medium);
    //padding: calc(var(--webmodule-spacing-small) - 1px) 0;
  }

  .checkbox--large {
    --toggle-size: var(--webmodule-toggle-size-large);
    font-size: var(--webmodule-control-font-size-large);
    //padding: calc(var(--webmodule-spacing-small) + 2px) 0;
  }

  .checkbox__control {
    flex: 0 0 auto;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--toggle-size);
    height: var(--toggle-size);
    border: solid var(--webmodule-control-border-width) var(--webmodule-control-border-color);
    border-radius: 2px;
    background-color: var(--webmodule-control-background-color);
    color: var(--webmodule-color-neutral-0);
    transition:
      var(--webmodule-animate-fast) border-color,
      var(--webmodule-animate-fast) background-color,
      var(--webmodule-animate-fast) color,
      var(--webmodule-animate-fast) box-shadow;
  }

  .checkbox__input {
    position: absolute;
    opacity: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }

  .checkbox__checked-icon,
  .checkbox__indeterminate-icon {
    display: inline-flex;
    width: var(--toggle-size);
    height: var(--toggle-size);
  }

  /* Hover */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__control:hover {
    border-color: var(--webmodule-control-border-color-hover);
    background-color: var(--webmodule-control-background-color-hover);
  }

  /* Focus */
  .checkbox:not(.checkbox--checked):not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: var(--webmodule-focus-border);
    outline-offset: var(--webmodule-focus-border-offset);
  }

  /* Checked/indeterminate */
  .checkbox--checked .checkbox__control,
  .checkbox--indeterminate .checkbox__control {
    border-color: var(--webmodule-color-primary-500);
    background-color: var(--webmodule-color-primary-500);
  }

  /* Checked/indeterminate + hover */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__control:hover,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__control:hover {
    border-color: var(--webmodule-color-primary-400);
    background-color: var(--webmodule-color-primary-400);
  }

  /* Checked/indeterminate + focus */
  .checkbox.checkbox--checked:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control,
  .checkbox.checkbox--indeterminate:not(.checkbox--disabled) .checkbox__input:focus-visible ~ .checkbox__control {
    outline: var(--webmodule-focus-border);
    outline-offset: var(--webmodule-focus-border-offset);
  }

  /* Disabled */
  .checkbox--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .checkbox__label {
    display: inline-block;
    color: var(--webmodule-control-label-color);
    line-height: var(--toggle-size);
    margin-inline-start: 0.5em;
    user-select: none;
    -webkit-user-select: none;
  }

  :host([required]) .checkbox__label::after {
    content: var(--webmodule-control-required-content);
    color: var(--webmodule-control-required-content-color);
    margin-inline-start: var(--webmodule-control-required-content-offset);
  }
`;
